import { isPresent } from '@yp/common/identity.ts';

// DNS: unit test.
const splitEmail = {
  [Symbol.split](str: string) {
    const result: string[] = [];
    let start = 0;
    let last = '';
    for (let i = 1; i < str.length; ++i) {
      const c = str[i];
      if (c === '@' || c === '.') {
        result.push(str.slice(start, i));
        start = i;
      } else if (last === '@' || last === '.') {
        result.push(str.slice(start, i));
        start = i;
      }
      last = c;
    }
    if (start < str.length) {
      result.push(str.slice(start));
    }
    return result;
  },
};

export function breakEmail(email: string) {
  // iOS doesn't support lookbehind "(?<...)" and confuses them with group specifiers.
  // return email.split(/(?=[@.])|(?<=[@.])/);
  return email.split(splitEmail);
}

export interface NavLink {
  path: string;
  label: string;
  isPrefix?: boolean;
}

export function isActive(link: NavLink, current: string) {
  return isPresent(link.isPrefix) ? current.startsWith(link.path) : current === link.path;
}

export function classes(...values: (string | undefined)[]) {
  return values.filter(Boolean).join(' ');
}

export function styles(...values: (string | undefined)[]) {
  return values.filter(Boolean).join('; ');
}
